export default {
  outList: [
    {
      light_point_1: [
        {
          title: '几何韵律前脸造型',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '徽派建筑“檐平脊正” 的美学范式'
        },
      ],
      light_point_3: [
        {
          title: '百万同源 全铝合金车身',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '6系航空级铝合金车身+钢覆超强骨架',
          text2: '一体式压铸成型塔顶，减重30%，扭转刚度31812N·m/deg'
        },
      ]
    }
  ],
  innerList: [
    {
      light_point_1: [
        {
          title: '15.6英寸中控大屏 + 9.2英寸仪表屏',
          type: 'image',
          video: '',
          image: 'lightPoint/4/2.jpg',
          text: '15.6英寸 高清大屏'
        },
      ],
      light_point_2: [
        {
          title: '大方轻奢内饰',
          type: 'image',
          video: '',
          image: 'lightPoint/4/3.jpg',
          text: '车内软包覆盖面积达2.036m²',
          text2: '3D Mesh清洁填充材料，无异味更环保',
        }
      ],
      light_point_3: [
        {
          title: '多维魔方大空间座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/4/4.jpg',
          text: '后排座椅放倒后可形成1539mm*1075mm移动卧室，后备箱容积450L，放平后可达1238L',
        },
      ]
    }
  ],
  tab1: [
    {
      title: '百万同源 全铝合金车身',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '6系航空级铝合金车身+钢覆超强骨架',
      text2: '一体式压铸成型塔顶，减重30%，扭转刚度31812N·m/deg'
    },
    {
      title: '豪华同源铸铝H臂',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '空心铸铝H臂悬架',
      text2: '抗冲击，操控好，降低路面冲击30%',
    },
    {
      title: '豪华同源底盘调教',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '余震抑制增强50%，转向响应提升30%'
    },
  ],
  tab2: [
    {
      title: '大方设计美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '时尚东方 大方无隅'
    },
    {
      title: '大方宽境外观',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '1950mm宽体车身'
    },
    {
      title: '几何韵律前脸造型',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '徽派建筑“檐平脊正” 的美学范式'
    },
    {
      title: '临风之岳车身侧型',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '轮高比2.35x，高视野一览无余的美学范式'
    },
    {
      title: '穹宇之门车尾造型',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: '豪华方盒同款侧开尾门',
      text2: '开启角度达89.8° ，越野范十足'
    },
    {
      title: '丰富可玩的生态产品',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '潮玩改装，物理按键。无限拓展 乐趣大开'
    },
  ],
  tab3: [
    {
      title: '68.36度动力电池',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '100千瓦快充功率，30-80%SOC仅需25分钟'
    },
    {
      title: '六合一超级电驱',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '后驱布局，零百加速6.9s',
      text2: '最大功率185kW，最大扭矩300N·m',
    },
    {
      title: '热泵空调',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '舒适不等待，续航更无忧',
      text2: '冬季用车续航可增加50-60公里',
    },
    {
      title: '“三明治”电池防护结构',
      type: 'image',
      video: '',
      image: 'lightPoint/3/4.jpg',
      text: '84%铝合金下壳体',
      text2: '采用航空级6系铝合金有效抵御碰撞'
    },
    {
      title: '12大主动安全辅助',
      type: 'image',
      video: '',
      image: 'lightPoint/3/5.jpg',
      text: '84%高速行车轻松，城市通勤舒适，一路安心护航',
      text2: '自动紧急制动（AEB）、智能远光灯（HMA）；自适应巡航（ACC）、540°透明底盘系统、哨兵模式'
    }
  ],
  tab4: [
    {
      title: '车规级8155芯片',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '105K DMIPS超高算力，四音区独立识别',
      text2: '30+微信小程序、聊天、唱K、打游戏，满足各种娱乐需求',
    },
    {
      title: '15.6英寸中控大屏 + 9.2英寸仪表屏',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '15.6英寸 高清大屏'
    },
    {
      title: '大方轻奢内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: '车内软包覆盖面积达2.036m²',
      text2: '3D Mesh清洁填充材料，无异味更环保',
    },
    {
      title: '多维魔方大空间座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/4.jpg',
      text: '后排座椅放倒后可形成1539mm*1075mm移动卧室，后备箱容积450L，放平后可达1238L',
    },
    {
      title: '女性友好配置',
      type: 'image',
      video: '',
      image: 'lightPoint/4/5.jpg',
      text: '柔光美颜化妆镜、舒云座椅、云台行车记录仪',
    }
  ]
}
